// Do not edit.
import { ShaderStore } from "core/Engines/shaderStore";

const name = "multiTextureCompositeAlphaBlendPixelShader";
const shader = `uniform highp sampler2DArray uLayers;uniform int uLayerCount;varying vec2 vUV;void main() {vec4 result=vec4(0.0);for (int i=0; i<MULTITEXTURE_MAXLAYERS; ++i) {if (i>=uLayerCount) break;vec4 s=texture(uLayers,vec3(vUV,float(i)));
#ifdef MULTITEXTURE_PREMULTIPLY
result=s+result*(1.0-s.a);
#else
result=vec4(s.rgb*s.a,s.a)+result*(1.0-s.a);
#endif
}
gl_FragColor=vec4((result.a>0.0) ? result.rgb/result.a : vec3(0.0),result.a);}
`;
// Sideeffect
if (!ShaderStore.ShadersStore[name]) {
    ShaderStore.ShadersStore[name] = shader;
}

/** @internal */
export const multiTextureCompositeAlphaBlendPixelShader = { name, shader };
